export default (context) => {
    let id =  document.getElementById('add-text-page__textarea');
    id.focus();
    context.pickColorsMarginBottom = id.offsetHeight + 7
    context.selectColorStatus = true
}